import { render, staticRenderFns } from "./HotelDetails.vue?vue&type=template&id=f5d30070&scoped=true"
import script from "./HotelDetails.vue?vue&type=script&lang=js"
export * from "./HotelDetails.vue?vue&type=script&lang=js"
import style0 from "./HotelDetails.vue?vue&type=style&index=0&id=f5d30070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d30070",
  null
  
)

export default component.exports